import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

const PALETTE = ['#0e48ad', '#17a2b8', '#28a745', '#fd7e14', '#e0a800', '#dc3545', '#6f42c1', '#6c757d'];

const centerTextPlugin = {
  id: 'centerText',
  afterDraw(chart) {
    const { ctx, chartArea } = chart;
    if (!chartArea) return;
    if (chart.data.labels.length === 1 && chart.data.labels[0] === 'Sem dados') return;
    const values = chart.data.datasets[0].data || [];
    const total = values.reduce((a, b) => a + b, 0);
    const x = (chartArea.left + chartArea.right) / 2;
    const y = (chartArea.top + chartArea.bottom) / 2;
    ctx.save();
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = '#0b3383';
    ctx.font = '700 22px "Segoe UI", sans-serif';
    ctx.fillText(String(total), x, y - 9);
    ctx.fillStyle = '#6c757d';
    ctx.font = '11px "Segoe UI", sans-serif';
    ctx.fillText('Total', x, y + 14);
    ctx.restore();
  },
};

const TipoDfdChart = ({ data }) => {
  const labels = Object.keys(data);
  const values = Object.values(data);

  const isEmpty = labels.length === 0;
  const finalLabels = isEmpty ? ['Sem dados'] : labels;
  const finalValues = isEmpty ? [1] : values;
  const backgroundColor = finalLabels.map((_, i) => PALETTE[i % PALETTE.length]);

  const chartData = {
    labels: finalLabels,
    datasets: [
      {
        data: finalValues,
        backgroundColor,
        borderWidth: 2,
        borderColor: '#fff',
        hoverOffset: 8,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '68%',
    plugins: {
      legend: {
        position: 'right',
        align: 'center',
        labels: {
          boxWidth: 11,
          boxHeight: 11,
          usePointStyle: true,
          pointStyle: 'circle',
          padding: 12,
          font: { size: 11 },
          color: '#495057',
          generateLabels: (chart) => {
            const ds = chart.data.datasets[0];
            return chart.data.labels.map((label, i) => ({
              text: `${label}: ${ds.data[i]}`,
              fillStyle: ds.backgroundColor[i],
              strokeStyle: ds.backgroundColor[i],
              lineWidth: 0,
              hidden: false,
              index: i,
            }));
          },
        },
      },
      tooltip: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        titleColor: '#fff',
        bodyColor: '#fff',
        borderColor: '#fff',
        borderWidth: 1,
        callbacks: {
          label: (context) => {
            const t = context.dataset.data.reduce((a, b) => a + b, 0);
            const pct = t > 0 ? ((context.parsed / t) * 100).toFixed(1) : 0;
            return `${context.label}: ${context.parsed} (${pct}%)`;
          },
        },
      },
    },
    layout: { padding: 6 },
    animation: { animateRotate: true, duration: 1000 },
  };

  return (
    <div className="d-flex flex-column h-100">
      <h5 className="text-center text-dark mb-2">DFD POR TIPO</h5>
      <div className="flex-grow-1">
        <Doughnut data={chartData} options={options} plugins={[centerTextPlugin]} />
      </div>
    </div>
  );
};

export default TipoDfdChart;
